export const socket_URL = "https://short-cms.ecotech.co.th";
export const API_URL = "https://short-cms.ecotech.co.th/api/";
export const imageUrl = "https://short-cms.ecotech.co.th/images/";
// export const socket_URL = "http://localhost:3222";
// export const API_URL = "http://localhost:3222/api/";
// export const imageUrl = "http://localhost:3222/images/";
export const TOKEN_KEY = "user";


// workflow-api-dv.ecotech.co.th